import {
    ATTENDANCE_GET_MULTIPLE,
    ATTENDANCE_GET_ONE,
    ATTENDANCE_REGISTER_SUCCESS,
    ATTENDANCE_REGISTER_FAIL,
    ATTENDANCE_LOADING,
    ATTENDANCE_LOADING_ERROR,
    ATTENDANCE_ACTIVATE_FAIL,
    ATTENDANCE_ACTIVATE_SUCCESS,
    ATTENDANCE_UPDATE_SUCCESS,
    ATTENDANCE_UPDATE_FAIL,
    ATTENDANCE_DELETE_SUCCESS,
    ATTENDANCE_DELETE_FAIL,
    ATTENDANCE_EDIT
} from "./../types/attendance";

let attendanceStore = JSON.parse(localStorage.getItem('attendance'))

const initialState = {
    isLoading: false,
    attendances: attendanceStore ? attendanceStore : [],
    attendance:{},
    msg: null,
    isEdit:-1,
    ref:null,
}

const changeState = (aluu, actid) =>
{
    let newAttendance = [...aluu];
    newAttendance.forEach(alu => {
        if(alu.id == actid.id){
            alu.is_active = actid.is_active
        }
    });
    return newAttendance;
}
const func =  function(state = initialState, action){
    switch (action.type) {
        case ATTENDANCE_EDIT:
            return {
                ...state,
                isEdit : action.payload
        };
        case ATTENDANCE_LOADING:
            return {
                ...state,
                isLoading : true
            };
        case ATTENDANCE_GET_MULTIPLE:
            localStorage.setItem('attendance', JSON.stringify(action.payload));
            return {
                ...state,
                attendances : action.payload,
                attendance : action.payload,
                isLoading : false,
                msg:'DONE!!!'
            };
        case ATTENDANCE_GET_ONE:
            let all = [...state.attendances];
            let ses = all.filter(row=>row.id == action.payload)[0];
            return {
                ...state,
                attendance : ses,
                MSG:"DONE!!!"
            };
        case ATTENDANCE_REGISTER_SUCCESS:
            localStorage.setItem('attendance', JSON.stringify([...state.attendances, action.payload]));
            return {
                ...state,
                attendances: [...state.attendances, action.payload],
                msg:action.msg
            }; 
        case ATTENDANCE_ACTIVATE_SUCCESS:
            let ac = changeState(state.attendances, action.payload);
            localStorage.setItem('attendance', JSON.stringify(ac));
            return{
                ...state,
                msg:'DONE!!!',
                attendances: ac
            }
        case ATTENDANCE_DELETE_SUCCESS:
            let rem = state.attendances.filter(cat => cat.id != action.payload);
            localStorage.setItem('attendance', JSON.stringify(rem));
            return{
                ...state,
                msg:'DONE!!!',
                attendances: rem
            }
        case ATTENDANCE_UPDATE_SUCCESS:
            const findInd = state.attendances.findIndex(cat => cat.id == action.payload.id);
            let newState = [...state.attendances];
            newState[findInd] = action.payload;
            localStorage.setItem('attendance', JSON.stringify(newState));
            return {
                ...state,
                ...action.payload,
                attendances : newState,
                attendance:action.payload
            }; 
        case ATTENDANCE_LOADING_ERROR:
        case ATTENDANCE_ACTIVATE_FAIL:
        case ATTENDANCE_REGISTER_FAIL:
        case ATTENDANCE_DELETE_FAIL:
        case ATTENDANCE_UPDATE_FAIL:

            return {
                ...state,
                isLoading: false,
                msg: action.msg
            };
        default:
            return state;
    }

}
export default func